import { ROWS_PER_PAGE_DEFAULT } from 'Util/constants'
import { TablePagination } from '@mui/material'

interface CustomTablePaginationProps {
  count: number
  page: number
  onPageChange: (event: unknown, newPage: number) => void
}

export default function CustomTablePagination({
  count,
  page,
  onPageChange
}: Readonly<CustomTablePaginationProps>) {
  return (
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={count}
      rowsPerPage={ROWS_PER_PAGE_DEFAULT}
      page={page}
      onPageChange={onPageChange}
    />
  )
}
